import { TeaserLinksProps } from './types';
import { cn, getColorway } from 'utils/styles';
import CopyTeaserLink from './CopyTeaserLink';
import { KeyLinePosition, Margins } from 'types/constants';
import IconTeaserLink from './IconTeaserLink';
import ImageTeaserLink from './ImageTeaserLink';
import TeaserLinkCarousel from './TeaserLinkCarousel';
import KeyLine from 'components/shared/KeyLine';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { TeaserLinksMargins, TeaserLinksLayouts } from './constants';

const getModifiedYMargins = (margins?: Margins | TeaserLinksMargins) => {
  switch (margins) {
    case TeaserLinksMargins.CenteredSlim:
      return 'sm:py-12 py-8';
    case Margins.NoBottom:
      return 'sm:pt-20 pt-12';
    case Margins.NoTop:
      return 'sm:pb-20 pb-12';
    case Margins.Centered:
    default:
      return 'sm:py-20 py-12';
  }
};

interface PillsNumber {
  [key: string]: string;
}

const getPillsClassName = (linksLength: string) => {
  const pillsNumber: PillsNumber = {
    '1': 'md:w-1/2',
    '2': 'md:w-1/3',
    '3': 'md:w-1/4',
    '4': 'md:w-1/5',
    '5': 'md:w-1/6',
    '6': 'md:w-1/7',
  };

  return pillsNumber[linksLength as keyof PillsNumber];
};

const TeaserLinks = ({ color, sectionName, linksCollection, layout, margins, headline, keyline }: TeaserLinksProps) => {
  const links = linksCollection.items;

  const showLinkGrid = layout === TeaserLinksLayouts.Copy;
  const showLinkCarousel = layout !== TeaserLinksLayouts.Copy;

  const showTopKeyline = keyline === KeyLinePosition.Top && margins !== Margins.NoTop;
  const showBottomKeyLine = keyline === KeyLinePosition.Bottom && margins !== Margins.NoBottom;

  return (
    <section className={`${getColorway(color)}`} {...(sectionName != null && { id: encodeURIComponent(sectionName) })}>
      <div className="content-wrapper">
        {showTopKeyline && <KeyLine />}
        <div
          className={cn(getModifiedYMargins(margins), {
            'pt-12 sm:pt-12': showTopKeyline,
            'pb-12 sm:pb-12': showBottomKeyLine,
          })}>
          {headline && (
            <div className="font-sans text-heading-md mb-8 pt-1.5">
              <RichTextHeadline headline={headline} />
            </div>
          )}
          {showLinkGrid && (
            <div className={cn('flex flex-col flex-wrap gap-y-4 sm:flex-row sm:flex-wrap sm:gap-x-4')}>
              {links.map((card, i) => (
                <CopyTeaserLink
                  {...card}
                  key={`${card.linkText}-${i}`}
                  className={`${getPillsClassName(links.length.toString())}`}
                  labelAs={headline ? 'h3' : undefined}
                />
              ))}
            </div>
          )}

          {showLinkCarousel && (
            <TeaserLinkCarousel totalItems={links.length}>
              {links.map((card, i) => {
                const TeaserLink = layout === TeaserLinksLayouts.Icon ? IconTeaserLink : ImageTeaserLink;
                return <TeaserLink {...card} key={`${card.linkText}-${i}`} />;
              })}
            </TeaserLinkCarousel>
          )}
        </div>

        {showBottomKeyLine && <KeyLine />}
      </div>
    </section>
  );
};

export default TeaserLinks;
